<template>
    <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <component :is="item" v-for="item in compList" :key="item" />
    </div>
</template>
<script>

import Top from "./Top";
import News from "./News";
import Roles from "./Roles";
import Games from "./Games";
import Face from "./Face";

export default {
    data() {
        return {
            compList: ["topPage", "facePage", "newsPage", "rolesPage", "gamePage"],
            intersectionOptions: {
                root: document.querySelector("#app"),
                rootMargin: "0px",
                threshold: 0.33 //范围为 0-1: 阈值为1.0意味着当100％的目标在root选项指定的元素中可见时，将调用回调
            }
        }
    },
    components: {
        topPage: Top,
        newsPage: News,
        rolesPage: Roles,
        gamePage: Games,
        facePage: Face,

    },
    methods: {
        onWaypoint({ going, direction }) {
            console.log("===", going, direction)
            if (going === this.$waypointMap.GOING_IN) {
                console.log('waypoint going in!')
            }

            if (direction === this.$waypointMap.DIRECTION_TOP) {
                console.log('waypoint going top!')
            }
        }
    }
}
</script>
